import * as React from "react";
const IconBuildingsAlt2 = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M58 17H44.7V7h2.8c.6 0 1-.4 1-1s-.4-1-1-1H16.4c-.6 0-1 .4-1 1s.4 1 1 1h2.8v10H6c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h52c2.2 0 4-1.8 4-4V21c0-2.2-1.8-4-4-4M42.7 7v36.8H21.3V7zM4 55V21c0-1.1.9-2 2-2h13.3v38H6c-1.1 0-2-.9-2-2m17.3-9.2h21.4V57H21.3zM60 55c0 1.1-.9 2-2 2H44.7V19H58c1.1 0 2 .9 2 2z" />
  </svg>
);
export default IconBuildingsAlt2;
